// Function to handle intersection changes
// function handleIntersection(entries, observer) {
//     entries.forEach(entry => {
//         if (entry.isIntersecting) {
//             entry.target.classList.add('show'); // Add 'show' class when section is in viewport
//         } else {
//             entry.target.classList.remove('show'); // Remove 'show' class when section is out of viewport
//         }
//     });
// }

// // Initialize Intersection Observer
// const observer = new IntersectionObserver(handleIntersection, {
//     root: null, // Use the viewport as the root
//     threshold: 0.5 // Trigger when 50% of the section is visible
// });

// // Observe the section
// const section = document.querySelector('#w-svg');
// console.log("section", section);
// if (section) {
//     observer.observe(section);
// }

// Wave Function
window.addEventListener("scroll", function () {
    waveOnScroll('.wave', 'animating', $(window).scrollTop());
});

function waveOnScroll(elem, classToAdd, distanceFromTop) {
    $(elem).each(function () {
        var winH = window.innerHeight,
            ElemH = $(this).outerHeight(),
            distTop = $(this).offset().top,
            distBottom = distTop + ElemH,
            scrollDistance = distanceFromTop,
            speedFactor = 1.5; // Adjust this value to increase the speed

        if (distTop <= scrollDistance + winH && distBottom >= scrollDistance) {
            if (!$(this).hasClass(classToAdd)) {
                $(this).addClass(classToAdd);
            }
            $(this).css("background-position-x", 1 * (distTop - scrollDistance) * speedFactor);
        } else {
            $(this).removeClass(classToAdd);
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const arrows = document.querySelectorAll('.bounce-arrow .pi-button--arrow');
  
    function checkVisibility() {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  
      arrows.forEach(arrow => {
        const rect = arrow.getBoundingClientRect();
        const isVisible = rect.top <= viewportHeight * 0.8 && rect.bottom >= 0;
  
        if (isVisible) {
          if (!arrow.classList.contains('bounce')) {
            // Trigger the bounce animation
            // arrow.style.opacity = 1;
            arrow.classList.add('bounce');
          }
        } else {
          // Reset state if not visible
        //   arrow.style.opacity = 0;
          arrow.classList.remove('bounce');
        }
      });
    }
  
    // Check visibility on scroll
    window.addEventListener('scroll', checkVisibility);
  
    // Check visibility on initial load
    checkVisibility();
  });


 /* document.addEventListener("DOMContentLoaded", function () {
    function updateInfoMargin() { 

       const viewportWidth = window.innerWidth;
       const viewportHeight = window.innerHeight;
       console.log(viewportHeight);

    // Run only if width is below 992px
      if (viewportWidth <= 1024) return;

      console.log('updateInfoMargin');
      const info = document.querySelector('.product__info-container');
      const product__media = document.querySelector('.product__media-list li:first-child');

      console.log(product__media.offsetHeight+'_testtetst');
      console.log(info.offsetHeight+'_testtetst');
      
      if (!info) return;
      // info.style.marginBottom = (info.offsetHeight / 2  - 195) + 'vh';
      info.style.marginBottom = '0vh';
      info.style.marginTop = '0vh';
      // info.style.height = (info.offsetHeight / 2  - 143) + 'vh';

      



       if (viewportWidth >= 1024 )
       {

        if(product__media.offsetHeight > info.offsetHeight)
            {
                var heightcal = (product__media.offsetHeight - info.offsetHeight ) / 2;

                var bottompadding =  heightcal / 2;

                info.style.paddingTop = heightcal+'px';
                info.style.paddingBottom = bottompadding+'px';
            }
        
       }
    }

    updateInfoMargin();
    window.addEventListener("resize", updateInfoMargin);
    document.addEventListener("variant:change", updateInfoMargin);
  });*/



 /*document.addEventListener("DOMContentLoaded", function () {
  function updateInfoMargin() {
    
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const info = document.querySelector(".product__info-container");
      const productMedia = document.querySelector(".product__media-list li:first-child");

        // Run only if width is above 1024px
      if (viewportWidth <= 767) {
        info.style.paddingTop = "0px";
        info.style.paddingBottom = "0px";
        return;
      }

      if (viewportWidth <= 1024) { 
        info.style.paddingTop = "0px";
        info.style.paddingBottom = "0px";
        info.style.opacity = "1"; return;
      }
        
      if (!info || !productMedia) return; // Ensure both exist
    
      info.style.paddingTop = "0px";
      info.style.paddingBottom = "0px";

      const mediaHeight = productMedia.offsetHeight;
      const infoHeight = info.offsetHeight;
      if (mediaHeight === 0 || infoHeight === 0) {
          requestAnimationFrame(updateInfoMargin);
          return;
      }
      if (mediaHeight > infoHeight) {
        const heightCal = (mediaHeight - infoHeight) / 2;
        const bottomPadding = heightCal / 2;
      
        info.style.paddingTop = `${heightCal}px`;
        info.style.paddingBottom = `${bottomPadding}px`;
      } else {
        info.style.paddingTop = "0px";
        info.style.paddingBottom = "0px";
      }
      info.style.opacity = "1";
    }

    
    // Run once after page load
    updateInfoMargin();

    // Run on resize (with debounce to prevent lag)
    let resizeTimeout;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateInfoMargin, 150);
    });

    // Run when variant changes
   // document.addEventListener("variant:change", updateInfoMargin);
});
*/


// document.addEventListener('variant:change', function (event) {
//   const mediaId = event.detail.variant?.featured_media?.id;
//   if (!mediaId) return;

//   const mediaItem = document.querySelector(
//     `.product__media-item[data-media-id*="${mediaId}"]`
//   );

//   if (!mediaItem) return;


//   const mediaList = mediaItem.closest('.product__media-list');
//   if (mediaList) {
//     mediaList.scrollLeft = mediaList.scrollLeft; // freeze scroll
//   }

//   document
//     .querySelectorAll('.product__media-item.fade-in')
//     .forEach(el => el.classList.remove('fade-in'));

//   mediaItem.classList.add('fade-in');
// });



 


// The complimentary box needs no script: its checkbox carries the line property itself (see
// snippets/pi-complimentary-box.liquid). The handler that used to be here wrote "No plastic box"
// into a hidden field the product page no longer has.


  

  